module.exports = __webpack_public_path__ + "img/overview-icon.acac66d6.svg";